import AuthenticatedData from "./authenticatedData";
import { pipelineForApp } from "../helpers/mappingHelper";
import { buildPayload } from "../helpers/payloadHelper";
import { isRunning, isSuccessful } from "../helpers/pipelineStatusHelper";

export default class Buildkite {
  constructor() {
    this.authenticatedData = new AuthenticatedData();
  }

  async getRunningBuilds(pipeline, token, callback) {
    const authData = await this.authenticatedData.getData(token);

    return this.fetchRunningBuilds(pipeline, authData.apiKey, callback);
  }

  async fetchRunningBuilds(pipeline, apiKey, callback) {
    const response = await fetch(
      `https://api.buildkite.com/v2/organizations/nulogy-corp/pipelines/${pipeline}/builds?branch=main&state[]=scheduled&state[]=running`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${apiKey}`,
          "Content-Type": "application/json",
        },
      },
    );

    if (response.ok) {
      const data = await response.json();

      callback(data);
    }

    setTimeout(() => {
      this.fetchRunningBuilds(pipeline, apiKey, callback);
    }, 10000);
  }

  async runPipeline(demoConfiguration, statusCallback, successCallback) {
    const authData = await this.authenticatedData.getData(
      demoConfiguration.token,
    );
    demoConfiguration.email = authData.email;
    demoConfiguration.apiKey = authData.apiKey;

    const payload = buildPayload(demoConfiguration);

    const response = await fetch(
      `https://api.buildkite.com/v2/organizations/nulogy-corp/pipelines/${pipelineForApp(
        demoConfiguration,
      )}/builds`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${demoConfiguration.apiKey}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      },
    );

    if (response.ok) {
      const data = await response.json();

      setTimeout(() => {
        demoConfiguration.statusUrl = data.url;

        this.checkStatus(demoConfiguration, statusCallback, successCallback);
      }, 30000);

      return data;
    }

    if (response.status === 401) {
      throw new Error("Unauthorized");
    }

    throw new Error("Error from buildkite");
  }

  async checkForUpdate(url, apiKey) {
    const response = await fetch(url, {
      headers: {
        Authorization: `Bearer ${apiKey}`,
      },
    });

    return response.json();
  }

  async getLog(url, apiKey) {
    const response = await fetch(url, {
      headers: {
        Authorization: `Bearer ${apiKey}`,
      },
    });

    return response.json();
  }

  async checkStatus(demoConfiguration, statusCallback, successCallback) {
    const { statusUrl, apiKey } = demoConfiguration;
    const status = await this.checkForUpdate(statusUrl, apiKey);

    if (isRunning(status.state)) {
      setTimeout(() => {
        this.checkStatus(demoConfiguration, statusCallback, successCallback);
      }, 30000);
    } else {
      if (isSuccessful(status.state) && demoConfiguration.app === "opsCore") {
        const create_test_demo_log_url = status.jobs.find(
          (job) => job.name?.match(/Create Test Demo/), // Re: CREATE_TEST_DEMO_JOB_NAME
        ).log_url;

        const create_test_demo_response = await this.getLog(
          create_test_demo_log_url,
          apiKey,
        );

        successCallback(create_test_demo_response, demoConfiguration);
      }
    }

    statusCallback(status, demoConfiguration);
  }
}
